import { render, staticRenderFns } from "./pageElementImage.vue?vue&type=template&id=475fd37d&scoped=true&"
import script from "./pageElementImage.vue?vue&type=script&lang=js&"
export * from "./pageElementImage.vue?vue&type=script&lang=js&"
import style0 from "./pageElementImage.vue?vue&type=style&index=0&id=475fd37d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475fd37d",
  null
  
)

export default component.exports